<template>
  <v-card>
    <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
      <v-toolbar dense :elevation="0" color="background darken-1">
        <v-toolbar-title>{{ $Amplify.I18n.get(title) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon color="secondary" @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-alert
          v-if="alert.message"
          v-model="alert.show"
          prominent
          dense
          dismissible
          :type="alert.type || 'error'"
          transition="scale-transition"
        >
          <v-layout align-center wrap>
            <div>
              {{ alert.message }}
            </div>
          </v-layout>
        </v-alert>
        <!--    {{ empresa.uuidEmpresa }} -->
        <ValidationProvider
          name="decripción"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            v-model="query.descripcion"
            :label="
              $Amplify.I18n.get('Escriba un nombre para la consulta') + ' *'
            "
            autofocus
            :error-messages="errors"
            :success="valid"
            outlined
            clearable
            @keyup.enter="editMode ? updateSaveQuery() : saveQuery()"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider name="uuidUsuario" rules="required">
          <strong>OPCIONES DE LA CONSULTA</strong>
          <v-radio-group v-model="query.owner" name="owner">
            <template v-slot:label>
              <div>Deseo que esta <strong>consulta</strong> sea visible:</div>
            </template>
            <v-radio :value="user.attributes['sub']" name="owner">
              <template v-slot:label>
                <div>
                  Solo para <strong class="primary--text">mí </strong> (<strong
                    >usuario:</strong
                  >
                  {{ user.username }})
                </div>
              </template>
            </v-radio>
            <v-radio value="*" name="owner">
              <template v-slot:label>
                <div>
                  Para <strong class="primary--text">todos</strong> los usuarios
                  de mi organización
                </div>
              </template>
            </v-radio>
            <!--   <v-radio value="[]" name="owner">
              <template v-slot:label>
                <div>
                  Para los usuarios
                  <strong class="primary--text"> seleccionados</strong>
                </div>
              </template>
            </v-radio> -->
          </v-radio-group>
        </ValidationProvider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          v-if="editMode"
          :disabled="invalid || !validated || loadingBtn"
          @click="updateSaveQuery()"
          color="primary"
          :loading="loadingBtn"
        >
          {{ $Amplify.I18n.get("Update Query") }}
          <template v-slot:loader>
            <span>{{ $Amplify.I18n.get("Wait...") }}</span>
          </template>
        </v-btn>

        <v-btn
          v-else
          :disabled="invalid || !validated || loadingBtn"
          @click="saveQuery()"
          color="primary"
          :loading="loadingBtn"
        >
          {{ $Amplify.I18n.get("Save Query") }}
          <template v-slot:loader>
            <span>{{ $Amplify.I18n.get("Wait...") }}</span>
          </template>
        </v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { AmplifyEventBus } from "aws-amplify-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapActions } from "vuex";
import { postConsulta, putConsulta } from "@/api/private/consultas";

export default {
  name: "FilterComponent",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {},
  data() {
    return {
      query: {
        descripcion: null,
        owner: ""
      },
      editMode: false,
      loadingBtn: false,
      alert: {
        show: false,
        type: "",
        message: ""
      },
      error: "",
      logger: {}
    };
  },
  computed: {
    ...mapGetters([
      "empresa",
      "user"
      // ...
    ]),
    title() {
      return this.editMode ? "Edit Saved Query" : "Save Query";
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
    //this.query.radios = this.user.attributes["sub"];
  },
  beforeCreate: function() {
    AmplifyEventBus.$on("edit-saved-query", query => {
      if (query) {
        this.editMode = true;
        Object.assign(this.query, query);
        this.$nextTick(() => {
          this.$refs.obs.validate();
        });
      }
    });
  },
  beforeDestroy: function() {
    AmplifyEventBus.$off("edit-saved-query");
  },
  watch: {},
  methods: {
    ...mapActions(["setQueriesAction", "hideSaveQueryDialog"]),
    saveQuery: async function() {
      this.loadingBtn = true;
      this.setAlert({});
      try {
        await postConsulta(this.query.descripcion, this.query.owner);
        AmplifyEventBus.$emit("load-saved-queries");
        this.close();
      } catch (e) {
        this.setError(e);
      } finally {
        this.loadingBtn = false;
        this.loading = false;
      }
    },
    updateSaveQuery: async function() {
      this.loadingBtn = true;
      this.setAlert({});
      try {
        await putConsulta(this.query, this.query.owner);
        AmplifyEventBus.$emit("load-saved-queries");
        this.close();
      } catch (e) {
        //console.log(e);
        this.setError(e);
      } finally {
        this.loadingBtn = false;
        this.loading = false;
      }
    },
    setError(e) {
      this.loadingBtn = false;
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.setAlert({ message: this.error });
      this.logger.error(this.error);
    },
    setAlert: function({ message = "", type = "error" }) {
      this.alert = {
        message,
        type,
        show: message.length > 1 ? true : false
      };
    },
    close: function() {
      this.hideSaveQueryDialog();
    }
  }
};
</script>
